module.exports = __webpack_public_path__ + "static/img/225_TO8_1964.288afbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/225_TO8_1964.jpg
// module id = nt5y
// module chunks = 0